module.exports = __webpack_public_path__ + "img/chest_gems.0dc2816a.png";